import axios from 'axios';
import { API_URL } from '../../config/api';
import { utcTime } from '../users/model';
export interface PasswordReset {
  id: number; user_id: number; user_username: string | null; user_name: string | null;
  user_email: string | null; user_avatar: string | null; is_used: boolean;
  expires_at: string | null; is_expired: boolean; created_at: string | null;
}
export interface ResetStats { total: number; used: number; unused: number; recent_requests: number; usage_rate: number }
export interface Filters { used: '' | 'yes' | 'no'; expired: '' | 'yes' | 'no' }
export const defaults: Filters = { used: '', expired: '' };
export const nameOf = (item: PasswordReset) => item.user_name || (item.user_username !== 'Unknown' && item.user_username) || `Kullanıcı #${item.user_id}`;
export const usernameOf = (item: PasswordReset) => item.user_username && item.user_username !== 'Unknown' ? `@${item.user_username}` : 'Kullanıcı adı yok';
export const statusOf = (item: PasswordReset) => item.is_used ? 'used' : item.is_expired ? 'expired' : 'waiting';
export const labels = { used: 'Kullanıldı', expired: 'Süresi doldu', waiting: 'Bekliyor' };
export function matches(item: PasswordReset, search: string, filters: Filters) {
  const text = [item.id, item.user_id, item.user_username, item.user_name, item.user_email].join(' ').toLocaleLowerCase('tr-TR');
  return text.includes(search.trim().toLocaleLowerCase('tr-TR')) && (!filters.used || item.is_used === (filters.used === 'yes')) && (!filters.expired || item.is_expired === (filters.expired === 'yes'));
}
export type Sort = 'created' | 'expiry' | 'name';
export function sortItems(items: PasswordReset[], sort: Sort) {
  const time = (item: PasswordReset) => { const raw = sort === 'expiry' ? item.expires_at : item.created_at; const value = raw ? utcTime(raw) : NaN; return Number.isFinite(value) ? value : sort === 'expiry' ? Infinity : -Infinity; };
  return [...items].sort((a, b) => sort === 'name' ? nameOf(a).localeCompare(nameOf(b), 'tr-TR') || a.id - b.id : time(a) === time(b) ? b.id - a.id : (time(a) < time(b) ? -1 : 1) * (sort === 'expiry' ? 1 : -1));
}
export async function fetchResets() {
  const items: PasswordReset[] = [], seen = new Set<number>(); let skip = 0, total = 0;
  while (skip < 100000) {
    const { data } = await axios.get<{total: number; tokens: PasswordReset[]}>(`${API_URL}/admin/password-resets`, { params: { skip, limit: 1000 } });
    if (!Array.isArray(data?.tokens) || !Number.isInteger(data.total) || data.total < 0) throw new Error('Invalid reset list');
    total = data.total;
    if (!data.tokens.length && skip < total) throw new Error('Incomplete reset list');
    for (const item of data.tokens) if (!seen.has(item.id)) { items.push(item); seen.add(item.id); }
    skip += data.tokens.length;
    if (skip >= total || !data.tokens.length) break;
  }
  return { items, total, partial: items.length < total };
}
export async function fetchStats(days: number) {
  if (!Number.isInteger(days) || days < 1 || days > 365) throw new Error('Invalid statistics period');
  const { data } = await axios.get<ResetStats>(`${API_URL}/admin/password-resets/stats`, { params: { days } });
  return data;
}
